import styled from 'styled-components';

export const Container = styled.div`
  & > div > div {
    display: block;
  }

  button {
    margin: 0;
  }
`;

export const Header = styled.div`
  & > div {
    height: inherit;
    padding-right: 45px;

    & > h1 {
      font-size: 17px;
      margin-bottom: 0;
    }
  }
`;
